import { Backdrop, Box, Button, Fade, Grid, IconButton, Modal } from "@mui/material";
import { Link } from "react-router-dom";
import { MdClose } from "react-icons/md"

interface IModalInvite {
    open: boolean;
    handleClose: () => void
}

export const ModalInvite = ({
    handleClose,
    open
}: IModalInvite) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute' as 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        maxWidth: 1405,
                        maxHeight: 500,
                        outline: 'none !important',
                        height: '80%',
                        width: '80%',
                        background: `
                        linear-gradient(to right, #006994, #008FC4, #00A0DE), 
                        linear-gradient(to left, #0080B2, #0074A1, #00A0DE)`,
                        backgroundSize: '100% 50%',
                        backgroundPosition: 'top, bottom',
                        backgroundRepeat: 'no-repeat',
                        '@media (min-width: 1624px)': {
                            background: 'transparent',
                        },
                        '@media (max-width: 1624px)': {
                            background: '#00A0DE !important',
                            maxWidth: 600,
                        },
                    }}
                >
                    <Grid
                        sx={{
                            position: 'absolute',
                            right: 20,
                            top: 20,
                            '@media (min-width: 1624px)': {
                                right: '4.5%',
                            },
                        }}
                    >
                        <IconButton onClick={handleClose}>
                            <MdClose size={24} color="white" />
                        </IconButton>
                    </Grid>
                    <Grid
                        sx={{
                            backgroundImage: `url("https://front-source-assets.s3.sa-east-1.amazonaws.com/acesso/assets/png/BANNER+EVENTO+SMALL.png")`,
                            backgroundPosition: 'center',
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            width: '100%',
                            height: '100%',
                            p: 2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-end',
                            flexDirection: 'column',
                            '@media (max-width: 1624px)': {
                                backgroundImage: `url("https://front-source-assets.s3.sa-east-1.amazonaws.com/acesso/assets/png/BANNER+MOBILE.png")`,
                            },

                        }}
                    >
                        <Link
                            to={"https://chat.whatsapp.com/F5s8xvMj7Tj1JpSVCzY6kz"}
                            target="_blank"
                        >
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: 'rgb(130, 173, 35)',
                                    textTransform: 'none !important',
                                    borderRadius: 10,
                                    padding: '20px 40px',
                                    lineHeight: 1.2
                                }}

                            >Entrar no grupo</Button>
                        </Link>
                    </Grid>
                </Box>
            </Fade>
        </Modal>
    )
}